// import ExportJsonExcel from 'js-export-excel';
import moment from 'moment';
import * as XLSX from 'xlsx';
export const download = (res, type, filename) => {
  // 创建blob对象，解析流数据
  const blob = new Blob([res], {
    // 设置返回的文件类型
    // type: 'application/pdf;charset=UTF-8' 表示下载文档为pdf，如果是word则设置为msword，excel为excel
    type: type,
  });
  // 这里就是创建一个a标签，等下用来模拟点击事件
  const a = document.createElement('a');
  // 兼容webkix浏览器，处理webkit浏览器中href自动添加blob前缀，默认在浏览器打开而不是下载
  const URL = window.URL || window.webkitURL;
  // 根据解析后的blob对象创建URL 对象
  const herf = URL.createObjectURL(blob);
  // 下载链接
  a.href = herf;
  // 下载文件名,如果后端没有返回，可以自己写a.download = '文件.pdf'
  a.download = filename;
  document.body.appendChild(a);
  // 点击a标签，进行下载
  a.click();
  // 收尾工作，在内存中移除URL 对象
  document.body.removeChild(a);
  window.URL.revokeObjectURL(herf);
};
export const isFunction = (o) => {
  return Object.prototype.toString.call(o).slice(8, -1) === 'Function';
};
// 处理枚举
function handvalueEnumdata(data, valueEnumObj) {
  // 获取枚举键名
  const keys = Object.keys(valueEnumObj);
  // 数据根据枚举的键名的处理数据
  keys.forEach((item) => {
    // 判断是否是函数，如果是函数就处理；
    if (isFunction(valueEnumObj[item])) {
      data[item] = valueEnumObj[item](data[item]);
    } else {
      data[item] = valueEnumObj[item][data[item]]?.text || data[item];
    }
  });
  return { ...data };
}
function getCellWidth(value) {
  // 判断是否为null或undefined
  if (value == null) {
    return 5;
  } else if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
    // 判断是否包含中文
    return value.toString().length * 3;
  } else {
    return value.toString().length * 3;
  }
}
/**
 * @description:
 * @param {type} fileName 文件名
 * @param {type} column 表格数列
 * @param {type} datas 表格数据
 * @return:
 */
export async function handleExport(fileName, column, datas, headerText = '') {
  try {
    // if(datas == false || datas === null) return message.error("暂无数据可导出");

    var option = {};
    var sheetFilter = [];
    var sheetHeader = [];
    var valueEnumObj = {};
    column.forEach((item) => {
      sheetFilter.push(item.dataIndex);
      sheetHeader.push(item.title);
    });
    const title = fileName || document.title;
    option.fileName = title + ' ' + moment().format('YYYY-MM-DD-HH-mm-ss');
    let newDatas = [];
    if (datas != false || datas !== null) {
      datas.forEach((item, index) => {
        item['index'] = index + 1;

        newDatas.push(handvalueEnumdata(item, valueEnumObj));
        // if (item.children) {
        //   item.children.forEach(key => {
        //     newDatas.push(key)
        //   })
        //   newDatas.push({})
        // }
      });
    }
    const columnWidths = new Array(sheetFilter.length).fill(20);
    sheetHeader.map((item, index) => {
      const currentValue = columnWidths[index];

      const newWidth = getCellWidth(item);
      if (newWidth > currentValue) {
        columnWidths[index] = newWidth;
      }
    });
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const cellRange = `A1:${String.fromCharCode(65 + sheetHeader.length - 1)}1`;
    ws['!merges'] = [
      { s: { c: 0, r: 0 }, e: { c: sheetHeader.length - 1, r: 0 } },
    ];
    XLSX.utils.sheet_add_aoa(ws, [[headerText]], { origin: 'A1' });
    XLSX.utils.sheet_add_aoa(ws, [sheetHeader], { origin: 'A2' });
    // 填充数据
    newDatas.forEach((row, index) => {
      //const rowData = Object.values(row); // 获取对象的值作为数组
      const rowData = column.map((i) => {
        return row[i.dataIndex];
      });
      XLSX.utils.sheet_add_aoa(ws, [rowData], {
        origin: `${cellRange.slice(0, 1)}${index + 3}`,
      });
    });
    columnWidths.forEach((width, index) => {
      ws['!cols'] = ws['!cols'] || [];
      ws['!cols'][index] = { wch: width };
    });
    // 将工作表添加到工作簿中
    XLSX.utils.book_append_sheet(wb, ws, '导入楼盘模板');

    // 导出Excel文件
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });

    // 创建下载链接
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = option.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.log(error);
  }
}
